var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6251 8.09166V7.50416C15.6251 4.28 13.1051 1.66666 10.0001 1.66666C6.89505 1.66666 4.37505 4.28 4.37505 7.50416V8.09166C4.37605 8.79296 4.17592 9.47983 3.79839 10.0708L2.87505 11.5083C2.03255 12.8208 2.67588 14.605 4.14172 15.02C7.97196 16.1047 12.0281 16.1047 15.8584 15.02C17.3242 14.605 17.9676 12.8208 17.1251 11.5092L16.2017 10.0717C15.8239 9.48075 15.6235 8.79388 15.6242 8.0925L15.6251 8.09166Z",
    stroke: "#3A4752",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6.25 15.8333C6.79583 17.29 8.26833 18.3333 10 18.3333C11.7317 18.3333 13.2042 17.29 13.75 15.8333M10 5V8.33333",
    stroke: "#3A4752",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkNotificationIcon);
export default __webpack_public_path__ + "static/media/dark-notification-icon.2a4e26dc894c8e9af0098c364741e707.svg";
export { ForwardRef as ReactComponent };